import Image from 'next/legacy/image';

export default function WebflowPaste() {
  return (
    <li>
      <h3 id="paste-webflow">Paste it in your Webflow site</h3>
      <p>
        Add a new <code>Embed</code> element on the webpage, in your Webflow project, and paste this
        code in the element.
      </p>

      <p>
        You may not see the archive from Stackblocks in the preview in Webflow, but it will show up
        once you export/publish the site.
      </p>
      <Image src="/guides/webflow-embed-button.png" width={1501} height={751} alt="webflow embed" />
      <Image
        src="/guides/webflow-embed-editor.png"
        width={1501}
        height={751}
        alt="webflow editor"
      />
      <p>
        <a href="https://university.webflow.com/lesson/custom-code-embed">Learn More</a>
      </p>
    </li>
  );
}
